// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 76 ? "common" : chunkId) + "." + {"76":"9808fd27","795":"fb23da21"}[chunkId] + ".chunk.css";
};